import { CoderNotesLookupType } from '../../../enums';
import { isIPC, isPathology } from '../../service-lines';

// Define a map of service line type detectors to their corresponding lookup configurations
const LookupConfigMap = [
  {
    matches: (serviceLine: string) => isIPC(serviceLine),
    getConfig: (item: CMxAPI.CaseRun) => ({
      lookupType: CoderNotesLookupType.ENCOUNTER_UID,
      lookupValue: item?.encounter_uid,
      titleName: 'Encounter',
      titleText: item?.alternate_visit_number
    })
  },
  {
    matches: (serviceLine: string) => isPathology(serviceLine),
    getConfig: (item: CMxAPI.CaseRun) => ({
      lookupType: CoderNotesLookupType.ACCESSION_NUMBER,
      lookupValue: item?.primary_clinical_identifier?.number,
      titleName: 'Accession',
      titleText: item?.primary_clinical_identifier?.number
    })
  }
];

// Default configuration
/**
 * Default configuration for coder notes lookup when no service line matches
 *
 * @param caseRun - The case run item containing encounter and visit information
 * @returns An object with default lookup parameters for coder notes
 */
const defaultConfig = (caseRun: CMxAPI.CaseRun) => ({
  lookupType: CoderNotesLookupType.ENCOUNTER_UID,
  lookupValue: caseRun?.encounter_uid,
  titleName: 'Encounter',
  titleText: caseRun?.alternate_visit_number
});

/**
 * Determines the appropriate lookup parameters for coder notes based on the service line of the active case run
 *
 * @param activeItem - The active case run item containing service line and other relevant data
 * @returns An object with lookupType, lookupValue, titleName, and titleText properties
 */
const getCoderNotesLookupParams = (activeItem: CMxAPI.CaseRun) => {
  // Find the first matching configuration or use default
  const matchingConfig = LookupConfigMap.find(config =>
    config.matches(activeItem?.service_line)
  );

  return matchingConfig
    ? matchingConfig.getConfig(activeItem)
    : defaultConfig(activeItem);
};

export { getCoderNotesLookupParams };
